import styled from 'styled-components';
import Typography from '../../../../components/basics/typography';
import Flex from '../../../../components/layout/flex';

export const DealSummaryGrid = styled(Flex)`
  justify-content: space-between;
  align-items: center;  
  padding-bottom: 2rem;
  margin-bottom: 3rem;
  border-bottom: 1px solid ${({theme}) => theme.colors.lightGray};
`;

export const DealSummaryTitle = styled(Typography)`
  margin-bottom: 0.25rem;
`